const mutations = {
  confirmCancelBookmark(state, confirmCancelBookmark) {
    state.confirmCancelBookmark = confirmCancelBookmark
  },
  deleteIndexBookmark(state, deleteIndexBookmark) {
    state.deleteIndexBookmark = deleteIndexBookmark
  },
  deleteLabelBookmark(state, deleteLabelBookmark) {
    state.deleteLabelBookmark = deleteLabelBookmark
  },
  denyDeleteBookmark(state, denyDeleteBookmark) {
    state.denyDeleteBookmark = denyDeleteBookmark
  },
  formBookmark(state, formBookmark) {
    state.formBookmark = formBookmark
  },
  isModalVisibleBookmark(state, isModalVisibleBookmark) {
    state.isModalVisibleBookmark = isModalVisibleBookmark
  },
  isValidBookmarkForm(state, isValidBookmarkForm) {
    state.isValidBookmarkForm = isValidBookmarkForm
  },
  promptDeleteBookmark(state, promptDeleteBookmark) {
    state.promptDeleteBookmark = promptDeleteBookmark
  },
}

export default mutations
